<template lang="pug">
.main-content
  .form-group
    span.col-md-12 タイプと搬送装置
    el-button(type='primary', icon='el-icon-plus', size='mini', @click='addTypeAndTransportDevice')
    .col-md-12.my-3.bg-light.border(v-for='(item, index) in formatData.type')
      .mt-3 タイプ
      el-input(type='text', value='', v-model='formatData.type[index]')
      .mt-3 搬送装置
      el-input.pb-3(type='text', value='', v-model='formatData.transportEquipment[index]', @blur='saveData()')
      el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteTypeAndTransportDevice(index)') 
  //- .form-group
  //-   label.col-md-12 標準品
  //-   .col-md-12
  //-     el-checkbox(name='standard_product', v-model='formatData.standardProduct', @change='saveData()')
  .form-group
    label.col-md-12 スコッチガン
    .col-md-12
      el-input(type='text', value='', v-model='formatData.scotch', @blur='saveData()')
  .form-group
    label.col-md-12 塗料供給装置
    .col-md-12
      el-input(type='text', value='', v-model='formatData.supplyDevice', @blur='saveData()')
  .form-group
    label.col-md-12 制御盤
    .col-md-12
      el-input(type='text', name='controle_panel', value='', v-model='formatData.controlePanel', @blur='saveData()')
</template>

<script>
export default {
  name: 'Format',
  data () {
    return {
    }
  },
  props: {
    formatData: Object
  },
  created () {
  },
  methods: {
    addTypeAndTransportDevice () {
      this.formatData.type.push('')
      this.formatData.transportEquipment.push('')
    },
    deleteTypeAndTransportDevice (index) {
      console.log(index)
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formatData.type.splice(index, 1)
        this.formatData.transportEquipment.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.hidden {
  visibility: hidden;
}

*:focus {
  outline: 0
}

</style>



// WEBPACK FOOTER //
// src/views/components/swan/techInfo/Format.vue